import AcceleratorDoc, {
  AcceleratorDocStoreKey,
} from "../../models/AcceleratorDoc";
import { Hydratable } from "../../models/hydration/Hydratable";
import { AcceleratorDocMetadataStore } from "../../stores/impl/AcceleratorDocMetadataStore";

export { HydratableDocError };
type Props = {
  acceleratorDoc: Hydratable<AcceleratorDoc> | undefined;
};

const HydratableDocError = (props: Props) => {
  if (props.acceleratorDoc) {
    // lookup
    const metadata = AcceleratorDocMetadataStore.getWithoutLookup(
      props.acceleratorDoc!._storeId as AcceleratorDocStoreKey,
    );
    if (metadata && metadata.loadingError) {
      return <span>Error loading document</span>;
    } else {
      return <span>Loading document data</span>;
    }
  } else {
    return <span>No document selected</span>;
  }
};
